export default {
  itens(state) {
    return state.itens;
  },
  selects(state) {
    return state.selects;
  }
};
